'use client'

import { Button } from 'components/Button'
import { trackGoal } from 'lib/analytics'
import { useTranslations } from 'next-intl'

interface Props {
  email: string
  topic: string
}

export function InquiryButton({ email, topic }: Props) {
  const t = useTranslations('contact')
  return (
    <a href={`mailto:${email}`}>
      <Button
        className="max-w-fit"
        onClick={() =>
          trackGoal('inquiry', {
            props: {
              topic,
              email,
            },
          })
        }
      >
        {t('inquiry')}
      </Button>
    </a>
  )
}

export function InquiryLink({ email, topic }: Props) {
  return (
    <a
      href={`mailto:${email}`}
      className="anchor"
      onClick={() =>
        trackGoal('inquiry', {
          props: {
            topic,
            email,
          },
        })
      }
    >
      {email}
    </a>
  )
}
